import http from "../../http-common"

class SearchRacExamService {
    getRacExamSearchResults(pageNumber:number) {
        return http.get(`/search/rac-exams?pageNumber=${pageNumber}`)
    }   
}


export default new SearchRacExamService();